module.exports = __webpack_public_path__ + "img/lf_bg.b69ceb41.png";